import { Component } from 'react';
//import Home from './Components/rah-kala/Home';
import Home from './Components/parssaman/Home';
import 'devextreme/dist/css/dx.light.css';
import notify from 'devextreme/ui/notify';
import './App.css';
import SideDivider from './Components/layout/SideDivider';
import StepCounter from './Components/utils/StepCounter';
import { isMobile } from 'react-device-detect';
import ParsSamanLogon from './Components/parssaman/ParsSamanLogon';
import { apiGetP, getCookie, setCookie } from './GanjiTools';

class App extends Component {
  constructor(prp) {
    super(prp);
    console.log('location = ', document.location?.href);
    window.mView = isMobile;

    window.notif = msg => {
      notify({
        message: msg, //Array.isArray(msg) ? msg.reduce((a, b) => a + ' ' + b) : msg,
        // height: 45,
        width: 350,
        // minWidth: 150,
        type: 'info',
        displayTime: 5000,
        rtlEnabled: true
      }, {
        position: 'bottom left',
        direction: 'up-stack',
      });
      console.log('>- NOTIFY: ', msg);
      //Array.isArray(msg) ? console.log('>- NOTIFY: ', ...msg) : console.log('>- NOTIFY: ', msg);
    }

    window.resetUser = () => {
      window.user = { id: 0 };
      const prj = window.config.PROJECT_NAME ?? 'project';
      setCookie(`${prj}_userid`, '0');
      setCookie(`${prj}_logonkey`, '');
      setCookie(`${prj}_user_fullname`, '');
    }

    window.logout = whenDone => {
      window.resetUser();
      // if (!whenDone) {
      //   this.state.mode = 'welcome';
      //   document.location = `${document.location.href?.split('/index.html')?.[0] ?? '.'}/index.html?mode=welcome`;
      //   return;
      // }
      this.setState({ mode: 'welcome', key: this.state.key + 1 }, whenDone);
    }

    //window.bodyHistory = [];

    window.reload = () => this.setState({ key: this.state.key + 1 });

    window.setFullBody = (component, whenDone, thenSaveToHistory) => {
      this.state.innerBody = undefined;

      this.setState({ fullBody: component, fullBodyKey: this.state.fullBodyKey + 1 }, whenDone);
    };

    window.forceReloadAfterMenuItemClicked = window.config.SWITCH_MODE !== 'single_page'; // 'single_page__reload_on_menu_command' // 'single_page' // 'multi_page' 

    window.setMode = window.config.SWITCH_MODE === 'multi_page' ?
      (
        (mode = 'form_route') => {
          if (mode === 'form_route' || !(mode?.length > 0))
            mode = App.findModeFromRoute();
          const location = document.location?.href?.split('/index.html')?.[0] ?? '';
          document.location = `${location}${location.endsWith('/') ? '' : '/'}index.html?mode=${mode}`;
        }
      )
      :
      (
        (mode = 'form_route', forceReload = window.forceReloadAfterMenuItemClicked) => forceReload
          ? this.setState({ mode: mode === 'form_route' ? App.findModeFromRoute() : mode, innerBodyKey: 1 + (this.state.innerBodyKey ?? 0) })
          : this.setState({ mode: mode === 'form_route' ? App.findModeFromRoute() : mode })
      );

    window.setInnerBody = (component, whenDone, thenSaveToHistory) => {
      this.state.fullBody = undefined;
      //window.uniPage?.saveStates?.();
      //SideDivider.innerBody = component;

      // if (thenSaveToHistory) {
      //   while (window.bodyHistory.length >= historySize)
      //     window.bodyHistory = window.bodyHistory.splice(1);

      //   window.bodyHistory.push(component);
      //   window.historyIndex = window.bodyHistory.length - 1;
      // }
      //console.log('setInnerBody');

      this.setState({ innerBody: component, innerBodyKey: this.state.innerBodyKey + 1 }, whenDone);
      //SideDivider.innerBodyRef?.forceUpdate?.();
    };

    window.setOrdersFilter = (mode, status, statusName, whenDone) => this.setState({ mode, status, statusName, bodyKey: this.state.bodyKey + 1 }, whenDone);
  }

  static findModeFromRoute(modeIfNothingInRoute) {
    const rl = document.location?.href?.split('?mode=');
    return (rl?.length === 2 && rl[1]) ?? modeIfNothingInRoute;
  }

  state = {
    innerBodyKey: 1,
    fullBodyKey: 1,
    serverIsConnected: false,
    innerBody: null,
    bodyKey: 1,
    mode: App.findModeFromRoute() ?? 'default', // 'missions',
    status: '',
    key: 1,
  };

  componentDidMount() {
    const prj = window.config.PROJECT_NAME ?? 'project';
    window.user = {
      logonkey: getCookie(`${prj}_logonkey`) ?? ''
    };

    apiGetP('/api/logon/whoAmI')
      .then(user => {
        window.user = user ?? { id: 0 };
        this.setState({ mode: App.findModeFromRoute() ?? 'default' });
      }).catch(() => window.user = { id: 0 })

  }

  render() {
    console.log('>> App.jsx state=', this.state, ' user=', window.user); //, 'config=', window.config);

    return (
      this.state.fullBody ??
      <Home innerBody={this.state.innerBody}
        key={`home_${this.state.key}_${this.state.innerBodyKey}_${this.state.mode}`}
        bodyKey={`${this.state.bodyKey}_${this.state.mode}`}
        mode={this.state.mode}
        status={this.state.status}
        statusName={this.state.statusName ?? ''}
        mobileAutoHideSideMenu={window.mView && window.config.SWITCH_MODE !== 'multi_page'}
      />
    );
  }
}

export default App;
